import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';
import { Lightbulb, Sparkles } from 'lucide-react';
interface HintButtonProps {
  onHint: () => {
    a: number;
    b: number;
    product: number;
  } | null;
  hintsRemaining: number;
  onBuyHints?: () => void;
}
export function HintButton({
  onHint,
  hintsRemaining,
  onBuyHints
}: HintButtonProps) {
  const [showModal, setShowModal] = useState(false);
  const [hint, setHint] = useState<{
    a: number;
    b: number;
    product: number;
  } | null>(null);
  const handleGetHint = () => {
    if (hintsRemaining <= 0) {
      setShowModal(true);
      return;
    }
    const hintData = onHint();
    if (hintData) {
      setHint(hintData);
      setShowModal(true);
    }
  };
  return <>
      <button onClick={handleGetHint} className="relative p-2 text-amber-500 hover:bg-amber-50 rounded-full transition-colors" data-id="element-103">
        <Lightbulb size={20} fill={hintsRemaining > 0 ? 'currentColor' : 'none'} data-id="element-104" />
        {hintsRemaining > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 bg-amber-500 text-white text-xs font-bold rounded-full flex items-center justify-center" data-id="element-105">
            {hintsRemaining}
          </span>}
      </button>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Hint" data-id="element-106">
        {hintsRemaining > 0 && hint ? <div className="space-y-4" data-id="element-107">
            <div className="p-4 bg-amber-50 rounded-xl border border-amber-200" data-id="element-108">
              <div className="flex items-center gap-2 mb-3" data-id="element-109">
                <Sparkles className="text-amber-500" size={20} data-id="element-110" />
                <span className="font-bold text-amber-900" data-id="element-111">Try this move:</span>
              </div>
              <div className="text-center space-y-2" data-id="element-112">
                <div className="text-4xl font-black text-amber-900" data-id="element-113">
                  {hint.a} × {hint.b} = {hint.product}
                </div>
                <p className="text-sm text-amber-700" data-id="element-114">
                  Set dial A to {hint.a} and dial B to {hint.b}
                </p>
              </div>
            </div>
            <p className="text-xs text-slate-500 text-center" data-id="element-115">
              {hintsRemaining - 1} hints remaining today
            </p>
            <Button fullWidth onClick={() => setShowModal(false)} data-id="element-116">
              Got it!
            </Button>
          </div> : <div className="space-y-4" data-id="element-117">
            <div className="text-center py-6" data-id="element-118">
              <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-119">
                <Lightbulb size={32} className="text-slate-400" data-id="element-120" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-121">
                No hints remaining
              </h3>
              <p className="text-sm text-slate-600" data-id="element-122">
                You've used all your free daily hints. Get more to continue!
              </p>
            </div>
            <div className="space-y-2" data-id="element-123">
              <Button fullWidth variant="primary" onClick={onBuyHints} data-id="element-124">
                Buy 10 Hints - 💎 100
              </Button>
              <Button fullWidth variant="outline" onClick={() => setShowModal(false)} data-id="element-125">
                Maybe Later
              </Button>
            </div>
          </div>}
      </Modal>
    </>;
}